<div *ngIf="calendarStartEndDate"
[ngClass]="{'selected-date-box-cursalab': theme === 'Cursalab', 'selected-date-box-IR' : theme === 'IR'}"
class="my-auto mx-auto  w-72 md:w-84 bg-white rounded-lg shadow-lg"
>
	<ion-row>
		<ion-col size="12" class="rounded-t-lg" [ngClass]="{'bg-cursalab': theme === 'Cursalab', 'bg-primary' : theme === 'IR'}">
			<div class="flex w-full p-3 justify-between">
				<div class="flex flex-col w-5/12">
					<label class="item-label text-white">Fecha inicio</label>
					<div class="custom-container-input w-full">
						<ion-input
							class="custom-text-input"
							placeholder="dd/mm/yyyy"
							[ngModel]="startDate"
							[readonly]="true"
						></ion-input>
					</div>
				</div>
				<div class="flex flex-col w-5/12">
					<label class="item-label text-white">Fecha fin</label>
					<div class="custom-container-input w-full">
						<ion-input
							class="custom-text-input"
							placeholder="dd/mm/yyyy"
							[ngModel]="endDate"
							[readonly]="true"
						></ion-input>
					</div>
				</div>
			</div>
		</ion-col>
	</ion-row>

	<ion-row class="px-5 pt-2">
		<ion-col size="12">
			<mat-calendar
				[selected]="selectedRange"
				(selectedChange)="onRangeDateSelected($event)"
			></mat-calendar>
		</ion-col>
	</ion-row>

	<ion-row class="px-5 pb-2 pt-1">
		<ion-col size="12" class="flex justify-end">
			<ion-button fill="clear"
			  class="reset-ion-style text-sm font-semibold"
			  [ngClass]="{'desempeno-color-primary-text': theme === 'Cursalab', 'text-primary' : theme === 'IR'}"
			  (click)="close()"
			>Cancelar</ion-button>
			<ion-button fill="solid"
				class="bg-primary-cursalab text-sm font-semibold ml-5"
				[ngClass]="{'bg-primary-cursalab': theme === 'Cursalab', 'bg-primary' : theme === 'IR'}"
				(click)="saveRange()"
				[disabled]="!startDate || !endDate"
			>Guardar</ion-button>
		</ion-col>
	</ion-row>
</div>

<div *ngIf="calendarSimpleSelect"
	class="my-auto mx-auto w-72 md:w-84 bg-white rounded-lg box-shadow"
	[ngClass]="{'selected-date-box-cursalab': theme === 'Cursalab', 'selected-date-box-IR' : theme === 'IR'}"
>
	<ion-row>
		<ion-col size="12" class="rounded-t-lg" [ngClass]="{'bg-cursalab': theme === 'Cursalab', 'bg-primary' : theme === 'IR'}">
			<div class="w-full px-5 py-2">
				<p class="text-base font-semibold text-white mb-1">Seleccione la fecha</p>
				<p class="text-xl font-bold text-white">{{ selectedDate || '--/--/----' }}</p>
			</div>
		</ion-col>
	</ion-row>

	<ion-row class="px-5 pt-2">
		<ion-col size="12">
			<mat-calendar
				[selected]="selectedSimpleDate"
				[minDate]="minDate"
				(selectedChange)="onSimpleDateSelected($event)"
			></mat-calendar>
		</ion-col>
	</ion-row>

	<ion-row class="px-5 py-3">
		<ion-col size="12" class="flex justify-end">
			<ion-button
				fill="clear"
				class="reset-ion-style text-sm font-semibold"
				[ngClass]="{'desempeno-color-primary-text': theme === 'Cursalab', 'text-primary' : theme === 'IR'}"
				(click)="close()"
			>Cancelar</ion-button>
			<ion-button
				fill="solid"
				class="bg-primary-cursalab text-sm font-semibold ml-5"
				[ngClass]="{'bg-primary-cursalab': theme === 'Cursalab', 'bg-primary' : theme === 'IR'}"
				(click)="saveSimpleDate()"
					[disabled]="!selectedDate"
			>Guardar</ion-button>
		</ion-col>
	</ion-row>
</div>
